import React from 'react';
import { Grid } from '@mui/material';
import CaptionValue from '../../../../../../Components/CaptionValue/CaptionValue';
import DefaultDialogContent from './DefaultExtensionData';

const Dossier = function Dossier({
  name,
  campaignAdvancement,
  activityTypes,
  activityTypeName,
  extensionData,
}) {
  const importId = extensionData?.ImportId || extensionData?.importId;

  return (
    <Grid
      container
      spacing={4}
      sx={{
        alignItems: 'center',
        width: '100%',
      }}
    >
      <Grid size={12}>
        <DefaultDialogContent
          name={name}
          campaignAdvancement={campaignAdvancement}
          activityTypes={activityTypes}
          activityTypeName={activityTypeName}
          extensionData={extensionData}
        />
      </Grid>
      {importId && (
        <Grid size={8}>
          <CaptionValue
            caption="IMPORTID"
            captionColor="primary"
            captionStyle={{ fontWeight: 'bold', textTransform: 'uppercase' }}
            value={importId}
          />
        </Grid>
      )}
    </Grid>
  );
};

export default Dossier;
